
import { ReferralId } from './types';

// Mock storage for referral IDs (in a real app, this would be a database)
let referralIdBank: ReferralId[] = [];

// Get all referral IDs
export const getAllReferralIds = (): ReferralId[] => {
  return [...referralIdBank];
};

// Get the referral ID bank
export const getReferralIdBank = (): ReferralId[] => {
  return [...referralIdBank];
};

// Update the referral ID bank
export const updateReferralIdBank = (updatedBank: ReferralId[]): ReferralId[] => {
  referralIdBank = [...updatedBank];
  return referralIdBank;
};

// Save the referral ID bank (same as update in mock implementation)
export const saveReferralIdBank = (bank: ReferralId[]): ReferralId[] => {
  return updateReferralIdBank(bank);
};

// Add a single referral ID to the bank
export const addReferralId = (referralId: ReferralId): ReferralId => {
  referralIdBank.push(referralId);
  return referralId;
};

// Remove a referral ID from the bank
export const removeReferralId = (referralIdToRemove: string): boolean => {
  const initialLength = referralIdBank.length;
  referralIdBank = referralIdBank.filter(id => id.id !== referralIdToRemove);
  return referralIdBank.length < initialLength;
};

// Initialize with some mock data if the bank is empty
export const initializeReferralIdBank = (): void => {
  if (referralIdBank.length === 0) {
    // Add some mock data
    for (let i = 0; i < 50; i++) {
      const randomString = Math.random().toString(36).substring(2, 8).toUpperCase();
      const code = `REF${randomString}`;
      
      referralIdBank.push({
        id: `ref-${Date.now()}-${i}`,
        code,
        userId: '',
        instanceId: 'default-instance',
        status: 'unused',
        createdAt: new Date(),
        updatedAt: new Date(),
        isAssigned: false
      });
    }
    
    // Mark some as assigned
    for (let i = 0; i < 10; i++) {
      if (referralIdBank[i]) {
        referralIdBank[i].isAssigned = true;
        referralIdBank[i].userId = `user-${i}`;
        referralIdBank[i].status = 'active';
        referralIdBank[i].assignedAt = new Date();
      }
    }
  }
};

// Initialize the bank on module load
initializeReferralIdBank();
